



































































import { Component } from 'vue-property-decorator';

import { DxPopup } from 'devextreme-vue';

import { IApiService, IApiServiceContract } from '@/api';
import { Inject } from '@/core/helpers';
import { Page } from '@/core/components/controls';
import { getTableCaption, Table, TableOptions } from '@/core/components/table';
import {
    LocalizationKeys,
    ComponentData,
    RelocationLimit,
    IRelocationLimitsTableData,
    RelocationLimitFormData,
} from './classes';
import {
    RelocationLimitsTable,
    RelocationLimitForm,
    MessageForm,
} from './components';
import { MessageFormData } from './classes/MessageFormData';

@Component({
    components: {
        RelocationLimitsTable,
        RelocationLimitForm,
        MessageForm,
        TableOptions,
        DxPopup,
    },
    filters: {
        tableCaption: (key: string) => getTableCaption(key),
    },
})
export default class RelocationLimitsPage extends Page {
    public LocalizationKeys = LocalizationKeys;
    public tableKey: string = 'relocation-limits-control';

    public table: Table | null = null;

    @Inject(IApiServiceContract)
    private apiService?: IApiService;

    private readonly componentData: ComponentData = new ComponentData();

    private relocationLimitFormShown: boolean = false;
    private relocationLimitFormData?: RelocationLimitFormData;

    private isDeleteErrorFormShown: boolean = false;
    private deleteErrorFormData: MessageFormData;

    constructor() {
        super();

        this.deleteErrorFormData = new MessageFormData(() =>
            this.closeDeleteErrorForm()
        );
    }

    public created() {
        if (!this.apiService) {
            throw new Error('apiService is not set');
        }

        // Begins data loading from the backend.
        this.componentData.load(this.apiService);
    }

    public setTable(table: Table): void {
        this.table = table;
    }

    private get tableData(): IRelocationLimitsTableData {
        return this.componentData.tableData;
    }

    private get isRelocationLimitFormShown(): boolean {
        return this.relocationLimitFormShown;
    }
    private get hasSelectedRelocationLimits(): boolean {
        return this.getSelectedRows().length > 0;
    }
    private get hasSelectedOneRelocationLimit(): boolean {
        return this.getSelectedRows().length === 1;
    }

    private onCreateRelocationLimitClick(): void {
        this.relocationLimitFormData = new RelocationLimitFormData(
            this.componentData,
            formResult => this.closeRelocationLimitForm(formResult),
            this.apiService!
        );
        this.relocationLimitFormData.formTitle =
            LocalizationKeys.RelocationLimitCreateFormTitle;
        this.relocationLimitFormShown = true;
    }
    private async onEditRelocationLimitClick(): Promise<void> {
        // Get selected rows
        const relocationLimits = this.getSelectedRows();
        // Check selection
        if (relocationLimits && relocationLimits.length === 1) {
            this.relocationLimitFormData = new RelocationLimitFormData(
                this.componentData,
                formResult => this.closeRelocationLimitForm(formResult),
                this.apiService!,
                relocationLimits[0]
            );
            this.relocationLimitFormData.formTitle =
                LocalizationKeys.RelocationLimitEditFormTitle;
            this.relocationLimitFormShown = true;
        }
    }
    private async onDeleteRelocationLimitClick(): Promise<void> {
        // Get selected rows
        const relocationLimits = this.getSelectedRows();
        // Check selection
        if (relocationLimits && relocationLimits.length > 0) {
            try {
                // Delete Relocation Limits
                await this.componentData.delete(
                    this.apiService!,
                    relocationLimits
                );

                // Refresh Table Content
                this.refreshTable();
            } catch (ex) {
                this.showDeleteErrorForm(ex);
            }
        }
    }
    private closeRelocationLimitForm(formResult: boolean): void {
        this.relocationLimitFormShown = false;
        if (formResult) {
            this.componentData.load(this.apiService!);
            this.table!.refresh();
        }
    }
    private showDeleteErrorForm(error: any): void {
        this.deleteErrorFormData.message = error.toString();
        this.isDeleteErrorFormShown = true;
    }
    private closeDeleteErrorForm(): void {
        this.isDeleteErrorFormShown = false;
        delete this.deleteErrorFormData.message;

        // Refresh Table Content
        this.refreshTable();
    }
    private getSelectedRows(): RelocationLimit[] {
        return this.componentData.tableData.selectedRelocationLimits;
    }
    private refreshTable(): void {
        this.componentData.load(this.apiService!);
        this.table!.refresh();
    }
}
